export default "__VITE_ASSET__BHqN9K12__"